module.exports = __webpack_public_path__ + "img/zeiljachten--white.33414d46.svg";